export default __webpack_public_path__ + "static/media/aboutus1.fd357c71.png";